import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Phone } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { IMAGES } from "../content";

export const CtaSection = () => (
  <section className="relative px-4 sm:px-8 lg:px-16 pb-24 max-w-7xl mx-auto" data-testid="cta-section">
    <Reveal>
      <div className="relative rounded-3xl overflow-hidden border border-white/10">
        <img src={IMAGES.city_lights} alt="City lights from orbit" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#05070A] via-[#05070A]/85 to-[#05070A]/40" />
        <div className="relative px-8 sm:px-14 py-16 sm:py-20 max-w-2xl">
          <Overline>LET'S BUILD TOGETHER</Overline>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white mt-4 leading-[1.08]">
            Let's get started with your project
          </h2>
          <p className="mt-4 text-slate-300 text-base sm:text-lg leading-relaxed">
            Tell us the geography, the dataset, or the problem — our geospatial experts will map the fastest route to a solution.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-4">
            <Link
              to="/contact"
              data-testid="cta-contact-button"
              className="group flex items-center gap-2 bg-cyan-400 text-[#05070A] font-semibold px-7 py-3.5 rounded-full hover:bg-cyan-300 hover:shadow-[0_0_36px_rgba(0,240,255,0.5)] transition-all duration-300"
            >
              Leave a message
              <ArrowUpRight size={17} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </Link>
            <a
              href="tel:08842355449"
              data-testid="cta-call-button"
              className="flex items-center gap-2 border border-white/20 text-white font-medium px-7 py-3.5 rounded-full hover:border-cyan-400/60 hover:text-cyan-300 transition-all duration-300"
            >
              <Phone size={16} /> Get on a call
            </a>
          </div>
        </div>
      </div>
    </Reveal>
  </section>
);
